<div>
    <div style="padding: 20px">
        <nz-input-group nzPrefixIcon="search">
            <input nzAllowClear style="padding: 10px" (keyup)="search($event)" type="text" nz-input
                placeholder="Search by Name" />
        </nz-input-group>
    </div>

    <div>
        <nz-table #userTable [nzData]="usersList" [nzLoading]="spinner" nzBordered nzShowSizeChanger>
            <thead>
                <tr>
                    <!-- <th>ID</th> -->
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <!-- <th>Distributor</th> -->
                    <th>Status</th>
                    <th *ngIf="hasPermission('manage_users')"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let u of userTable.data">
                    <!-- <td>{{ u.user_id }}</td> -->
                    <td>{{ u.first_name | titlecase }} {{ u.last_name | titlecase }}</td>
                    <td>{{ u.email }}</td>
                    <td>{{ phoneNumberDisplay(u.phone?.toString()) || '' }}</td>
                    <td>{{ u.company_name }}</td>
                    <!-- <td>{{ u.distributor }}</td> -->
                    <td>
                        <nz-tag [nzColor]="u.uir_status == 'pending' ? 'red' : 'yellow'">
                            {{ u.uir_status | titlecase }}
                        </nz-tag>
                    </td>
                    <td *ngIf="hasPermission('manage_users')">
                        <div style="display: flex; justify-content: center; gap: 5px;">
                            <button nz-button nz-popover nzPopoverContent="Update User" nzType="primary"
                                nzShape="circle" (click)="showModal(u)">
                                <span nz-icon nzType="edit" nzTheme="outline"></span>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>

<nz-modal [(nzVisible)]="updateModal" nzTitle="User" nzCentered (nzOnCancel)="cancelModal()" (nzOnOk)="confirmModal()">
    <ng-container *nzModalContent>
        <form [formGroup]="updateForm">
            <nz-form-control>
                <nz-form-label nzFor="dropdownField" nzTooltipTitle="Select a status for the user."
                    nzTooltipIcon="info-circle">
                    User status
                </nz-form-label>
                <nz-select formControlName="status" nzPlaceHolder="Select a status for the user">
                    <nz-option nzValue="pending" nzLabel="Pending"></nz-option>
                    <nz-option nzValue="snoozed" nzLabel="Push Back"></nz-option>
                    <nz-option nzValue="inactivated" nzLabel="Inactive"></nz-option>
                </nz-select>
                <div style="margin-top: 15px;">
                    <label for="noteInput">Note</label>
                    <textarea id="noteInput" formControlName="note" rows="3" style="width: 100%; padding: 8px;"></textarea>
                </div>

                <!-- <nz-select formControlName="status">
                    <nz-option nzValue="jack" nzLabel="Jack"></nz-option>
                    <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
                    <nz-option nzValue="disabled" nzLabel="Disabled" nzDisabled></nz-option>
                </nz-select> -->
            </nz-form-control>
        </form>
    </ng-container>
</nz-modal>
